import { render, staticRenderFns } from "./KAM001-v2.vue?vue&type=template&id=71db7c0c"
import script from "./KAM001-v2.vue?vue&type=script&lang=ts"
export * from "./KAM001-v2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports